import React, {useContext} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft} from '@fortawesome/free-solid-svg-icons';
import { LabelText } from '../../../components/Language';
import { OverviewContext } from '../../context/OverviewProvider';
import Aux from '../../../hoc/Auxiliary';
import './index.css';

export default function OverviewDetailFooter(props) {
    const { dataError, handlerOnBackBtnClick } = useContext(OverviewContext);

    return (         
        <Aux> 
            <div className="Back-container-footer">
                <button className="back-btn" onClick={() => handlerOnBackBtnClick(dataError && dataError.size > 0 ? 
                    true : false)}>
                    <FontAwesomeIcon className ="Angle-left-icon" icon = {faAngleLeft}/><LabelText tid="Back" />
                </button>
            </div>
        </Aux>
    )
}